import { webCrypto } from '#web-crypto';
import { arrayToBase16, arrayToBase32, arrayToBase64, } from './binary-utils';
import { NONCE_RANDOM_BYTES, SALT_RANDOM_BYTES } from './constants';
export const generateRandomBytes = (length) => webCrypto.getRandomValues(new Uint8Array(length)).buffer;
export const generateRandomBase64EncodedString = (randomBytesLength, options) => {
    const randomBytes = generateRandomBytes(randomBytesLength);
    return arrayToBase64(randomBytes, options);
};
export const generateRandomBase32EncodedString = (randomBytesLength) => arrayToBase32(generateRandomBytes(randomBytesLength));
export const generateRandomSalt = () => generateRandomBase64EncodedString(SALT_RANDOM_BYTES);
export const generateRandomNonce = () => generateRandomBase64EncodedString(NONCE_RANDOM_BYTES);
export const generateTraceId = () => generateRandomBase64EncodedString(27);
export const randomBsonObjectId = () => arrayToBase16(generateRandomBytes(12));
